module.exports = "https://cdn.hellotech.com/client-assets/missing_110160a519085d9f2a7f68be7f7a892b.png";